import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge } from '../../material-ui/Badge';
import { ListItem, ListItemIcon, ListItemText } from '../../material-ui/List';
import { Limitation } from '../../../icons';
import { useDefectCounts } from '../../../selectors/defects';
import { useStyles } from './useStyles';

export const LimitationAdapter = memo(({ value, selected, onClick, className }) => {
    const { count, notDownloaded } = useDefectCounts();

    const { t: translate } = useTranslation();
    const classes = useStyles();

    const handleClick = useCallback(() => onClick(value), [onClick]);

    return (
        <ListItem onClick={handleClick} button={true} disabled={count === 0} selected={selected}>
            <ListItemIcon className={classes.listIcon}>
                <Badge
                    badgeContent={notDownloaded}
                    color="secondary"
                    max={999}
                    classes={{ anchorOriginTopRightRectangular: classes.badge }}
                >
                    <Limitation width="24" height="24" />
                </Badge>
            </ListItemIcon>
            <ListItemText primary={translate('labels.limitations')} className={className} />
        </ListItem>
    );
});

LimitationAdapter.displayName = 'LimitationAdapter';
